"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenSize = void 0;
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var window_size_1 = require("@react-hook/window-size");
function useScreenSize() {
    var _a = window_size_1.useWindowSize(), innerWidth = _a[0], innerHeight = _a[1];
    var orientation = innerWidth > innerHeight ? 'landscape' : 'portrait';
    var smallerThan = {
        mobile: innerWidth <= parseFloat(tokens_1.default.breakpointMobileLarge),
        tablet: innerWidth <= parseFloat(tokens_1.default.breakpointTablet),
        desktop: innerWidth <= parseFloat(tokens_1.default.breakpointDesktop),
        large: innerWidth <= parseFloat(tokens_1.default.breakpointLarge),
        widescreen: innerWidth <= parseFloat(tokens_1.default.breakpointWidescreen),
    };
    var largerThan = {
        mobile: innerWidth > parseFloat(tokens_1.default.breakpointMobileLarge),
        tablet: innerWidth > parseFloat(tokens_1.default.breakpointTablet),
        desktop: innerWidth > parseFloat(tokens_1.default.breakpointDesktop),
        large: innerWidth > parseFloat(tokens_1.default.breakpointLarge),
        widescreen: innerWidth > parseFloat(tokens_1.default.breakpointWidescreen),
    };
    return {
        smallerThan: smallerThan,
        largerThan: largerThan,
        innerWidth: innerWidth,
        innerHeight: innerHeight,
        orientation: orientation,
    };
}
exports.useScreenSize = useScreenSize;
//# sourceMappingURL=useScreenSize.js.map